document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".header__mob-nav");
    const menu = document.querySelector(".header__nav");
    
    if(btn && menu) {
        btn.addEventListener("click", function() {
            btn.classList.toggle("active");
            menu.classList.toggle("active");
            document.querySelector("header").classList.toggle("active");
            document.body.classList.toggle("no-scroll");
        })
        const subNav = menu.querySelectorAll(".sub-nav__image");
        if(subNav) {
            subNav.forEach(item => {
                item.addEventListener("mouseover", function() {
                    document.querySelector("img[data-id='" + item.dataset.id + "']").style.opacity = 1;
                    document.querySelector("img[data-id='" + item.dataset.id + "']").style.zIndex = 10;
                });
                item.addEventListener("mouseout", function() {
                    document.querySelector("img[data-id='" + item.dataset.id + "']").style.opacity = 0;
                    document.querySelector("img[data-id='" + item.dataset.id + "']").style.zIndex = 0;
                });
            })
        }
    }
});